import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { Backend } from 'src/app/backend-interface/backend';
import { NgbTimepicker, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from 'src/app/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';


@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  standalone: true,
  providers: [DatePipe, TranslationService],
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatButtonModule,
    MatDateFnsModule ,
    FormsModule,
    CommonModule,
    NgbTimepicker
  ],
})
export class DatepickerComponent implements OnChanges {
  @Input() attestation = false;
  @Input() stampdebut?: number;
  @Input() stampfin?: number;
  @Input() min_date?: Date;

  public readonly translationService = inject(TranslationService);
  private readonly datepipe = inject(DatePipe);

  range = new FormGroup({
    debut: new FormControl<Date | null>(null),
    fin: new FormControl<Date | null>(null),
  });

  myTimePickerBegin: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  myTimePickerEnd: NgbTimeStruct = { hour: 23, minute: 59, second: 0 };
  public readonly dateFormat = this.translationService.getDateFormat().toLocaleUpperCase();

  @Output() myDatePicker = new EventEmitter<[number, number]>();

  formatDate(time: Date): string {
    return Backend.FORMAT.onlyDate(time.getTime(), this.datepipe) ?? '';
  }

  public returnDebutFin(debut: number, fin: number): void {
    const vdebut = new Date(debut);
    let vfin: Date;
    if (this.myTimePickerBegin) {
      vdebut.setHours(this.myTimePickerBegin.hour);
      vdebut.setMinutes(this.myTimePickerBegin.minute);
    } else {
      vdebut.setHours(0, 0, 0, 0);
    }
    if (fin) {
      vfin = new Date(fin);
      if (this.myTimePickerEnd) {
        vfin.setHours(this.myTimePickerEnd.hour);
        vfin.setMinutes(this.myTimePickerEnd.minute);
      } else {
        vfin.setHours(23, 59, 59, 999);
      }
    } else {
      vfin = new Date(vdebut);
      if (this.myTimePickerEnd) {
        vfin.setHours(this.myTimePickerEnd.hour);
        vfin.setMinutes(this.myTimePickerEnd.minute);
      } else {
        vfin.setHours(23, 59, 59, 999);
      }
      this.range.patchValue({ fin: vfin });
    }
    this.myDatePicker.emit([vdebut.getTime(), vfin.getTime()]);
  }

  getTimePickerErrors(): string {
    if (this.myTimePickerBegin && this.myTimePickerEnd && this.myTimePickerEnd.hour < this.myTimePickerBegin.hour) {
      this.translationService.get('component-datepicker-error-time').subscribe((res: string) => {
        return res;
      });
    }
    return '';
  }

  ngOnChanges(): void {
    if (this.stampdebut && this.stampfin) {
      this.range.patchValue({ debut: new Date(this.stampdebut), fin: new Date(this.stampfin) });
    }
  }

  today(): Date {
    return new Date(Backend.FORMAT.today());
  }
}
